import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Textarea } from "../ui/textarea";

export function UsageReviewDialog({ target, onClose, onDone }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  if (!target) return null;
  const isReject = target.mode === "tolak";
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/asset-usages/${target.row.id}/${target.mode}`, { note });
      toast.success(isReject ? "Penolakan terkirim ke penerima" : "Jawaban terkirim ke admin");
      setNote(""); onClose(); onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="dialog-usage-review">
        <DialogHeader><DialogTitle className="font-heading">{isReject ? "Tolak / Pertanyakan Pengajuan Pemasangan" : "Jawab Pertanyaan Admin"}</DialogTitle></DialogHeader>
        <div className="text-xs text-muted-foreground">{target.row.item_name} × {target.row.qty} — {target.row.location}</div>
        {!isReject && target.row.review_note && <div className="rounded-lg bg-rose-500/10 border border-rose-500/30 px-3 py-2 text-xs"><b>Pertanyaan admin:</b> {target.row.review_note}</div>}
        <Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder={isReject ? "Tulis alasan penolakan / pertanyaan untuk teknisi kepala (mis. kenapa gratis? lokasi mana?)..." : "Jelaskan alasan pemasangan ini..."} data-testid="usage-review-note" />
        <Button onClick={submit} disabled={busy || !note.trim()} className={`w-full text-white ${isReject ? "bg-rose-600 hover:bg-rose-700" : "bg-sky-600 hover:bg-sky-700"}`} data-testid="usage-review-submit">{busy ? "Mengirim..." : isReject ? "Kirim Penolakan" : "Kirim Jawaban"}</Button>
      </DialogContent>
    </Dialog>
  );
}
